export { default as Fileupload } from './Fileupload';



// WEBPACK FOOTER //
// ./src/features/fileupload/index.js